import _ from 'lodash';


export default class PromoCode {
  fields = {
    id: {
      value: null
    },
    rate_id: {
      value: null
    },
    text: {
      value: null
    },
    use_count: {
      value: null
    },
    use_limit: {
      value: null
    },
    expires_on: {
      value: null
    },
    used_on: {
      value: null
    },
    is_active: {
      value: null
    },
    created_at: {
      value: null
    },
    updated_at: {
      value: null
    }
  };


  static createFromQueryValues(values) {
    const promoCode = new this();

    for (let field in promoCode.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'expires_on':
          case 'used_on':
          case 'created_at':
          case 'updated_at':
            promoCode.fields[field].value = (values[field] === null) ?
              values[field] :
              new Date(Number(values[field]));
            break;
          default:
            promoCode.fields[field].value = values[field];
        }
      }
    }

    return promoCode;
  }


  getQueryFieldValues() {
    if (this.fields.text.value === null) {
      return false;
    }

    const values = _.cloneDeep(PromoCodeInput);

    for (let field in values) {
      switch (field) {
        case 'id':
          if (this.fields[field].value === null) {
            delete values.id;
          }
          else {
            values[field] = this.fields[field].value;
          }
          break;
        case 'expires_on': // @CMN Ask Craig if we can remove this...
          const value = this.fields[field].value;
          if (value !== null) {
            const valueYear = value.getUTCFullYear();
            const valueMonth = (value.getUTCMonth() + 1);
            const valueDate = value.getUTCDate();
            const valueString = `${valueYear}-${valueMonth}-${valueDate}`;
            values[field] = valueString;
          }
          break;
        default:
          values[field] = (this.fields[field].value === '') ? null : this.fields[field].value;
      }
    }

    return values;
  }
}


export const PromoCodeInput = {
  id: null,
  text: null,
  use_limit: null,
  expires_on: null
}
